import React, { useRef, useState, useEffect } from "react"

import Layout from "../components/layout"

import BlogMenu from "../content/blog/blog_menu"
import BlogCarousel from "../content/blog/blog_carousel"

import { usePrismBlogs } from "../hooks/use_prism-blogs"

import "../styles/pages/blog/blog.scss"
import { BlogItem, BlogItemTypes } from "../components/_blog/_blog_item"
import { BlogSearch } from "../components/_blog/_blog_search"

const BlogPage = () => {
  const blogs = usePrismBlogs()
  const blog_body = useRef(null)
  const [append, setAppend] = useState(false)
  const [newBlogs, setNewBlogs] = useState([])
  const single_layout_array = ["left", "middle", "right"]
  const [blog_current, set_blog_current] = useState(3)
  let blog_total = blogs.edges.length - 1

  const [has_more, setHasMore] = useState(blog_total > 7)

  useEffect(() => {
    /* eslint-disable */
    if (append) {
      let blog_array = []
      let to_add = 0
      let initial_count = blog_current

      if (blog_current + 3 < blog_total) {
        to_add = 3
      } else {
        to_add = blog_total - blog_current
        setHasMore(false)
      }

      for (let i = 0; i < to_add; i++) {
        blog_array.push({
          blog: blogs.edges[initial_count],
          type: BlogItemTypes.SINGLE,
          single_layout: single_layout_array[i],
        })
        initial_count++
      }

      setNewBlogs([...newBlogs, ...blog_array])
      set_blog_current(blog_current + to_add)
      setAppend(false)
    }
  }, [append])

  return (
    <Layout _class="blog">
      <BlogSearch></BlogSearch>
      <div className="blog-container">
        <div className="blog_header_stage">
          <div className="blog_carrousel">
            <BlogCarousel datablogs={blogs}></BlogCarousel>
          </div>
          <BlogMenu path="/blog/"></BlogMenu>
        </div>
        <div className="blog_body" ref={blog_body}>
          {blogs.edges.length >= 2 ? (
            <BlogItem
              blog={blogs.edges[1]}
              type={BlogItemTypes.MAIN}
            ></BlogItem>
          ) : null}
          {blogs.edges.length >= 3 ? (
            <BlogItem
              blog={blogs.edges[2]}
              type={BlogItemTypes.TO_LEFT}
            ></BlogItem>
          ) : null}
          {blogs.edges.length >= 4 ? (
            <BlogItem
              blog={blogs.edges[3]}
              type={BlogItemTypes.TO_RIGHT}
            ></BlogItem>
          ) : null}
          {blogs.edges.length >= 5 ? (
            <BlogItem
              blog={blogs.edges[4]}
              type={BlogItemTypes.TO_LEFT}
            ></BlogItem>
          ) : null}
          {blogs.edges.length >= 6 ? (
            <BlogItem
              blog={blogs.edges[5]}
              type={BlogItemTypes.SINGLE}
              single_layout="left"
            ></BlogItem>
          ) : null}
          {blogs.edges.length >= 7 ? (
            <BlogItem
              blog={blogs.edges[6]}
              type={BlogItemTypes.SINGLE}
              single_layout="middle"
            ></BlogItem>
          ) : null}
          {blogs.edges.length >= 8 ? (
            <BlogItem
              blog={blogs.edges[7]}
              type={BlogItemTypes.SINGLE}
              single_layout="right"
            ></BlogItem>
          ) : null}
          {newBlogs.map((item, key) => (
            <BlogItem
              key={`blog_item_${key}`}
              blog={item.blog}
              type={item.type}
              single_layout={item.single_layout}
            ></BlogItem>
          ))}
        </div>
        {has_more ? (
          <div className="blog_footer">
            <a className="blog_footer_button" onClick={() => setAppend(true)}>
              <p className="blog_footer_text">Cargar más noticias</p>
            </a>
          </div>
        ) : null}
      </div>
    </Layout>
  )
}

export default BlogPage
